<div *ngIf="showHead">
  <nav class="navbar navbar-expand-lg fixed-top p-0 m-0">
    <div class="container-fluid mx-3">
      <button
        type="button"
        (click)="triggerManageDeductions()"
        class="logo-button"
        aria-label="Go to manage deductions"
      >
        <img
          alt="Logo"
          width="200"
          class="img-logo"
          [src]="ICON_PATHS.DMP_LOGO"
        />
      </button>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarScroll"
        aria-controls="navbarScroll"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="collapse navbar-collapse navbar-right-bg ms-3"
        id="navbarScroll"
      >
        <div class="row menu-container-upper-join">
          <div class="col menu-container-upper-join-1"></div>
          <div class="col menu-container-upper-join-2"></div>
        </div>
        <div
          class="collapse navbar-collapse"
          id="navbarNavAltMarkup"
        >
          <div class="navbar-nav submenu">
            <section
              class="nav-link"
              aria-current="page"
              *ngIf="userInfo.user_type !== 4"
              [ngClass]="showDashboardMenu === true ? 'activate' : ''"
              (click)="triggerDashboard()"
            >
              Dashboard
            </section>
            <section
              class="nav-link"
              [ngClass]="showManageMenu === true ? 'activate' : ''"
              (click)="triggerManageDeductions()"
            >
              Manage Deductions
            </section>
            <section
              class="nav-link"
              *ngIf="userInfo.user_type !== 4"
              [ngClass]="showReportMenu === true ? 'activate' : ''"
              (click)="triggerReport()"
            >
              Reporting
            </section>
            <section
              class="nav-link"
              *ngIf="userInfo.user_type !== 4"
              [ngClass]="showConnectorMenu === true ? 'activate' : ''"
              (click)="triggerConnector()"
            >
              Connectors
            </section>
          </div>
        </div>
        <ul class="navbar-nav ms-auto my-3 me-4 pe-1 my-lg-0 navbar-nav-scroll">
          <div
            class="icon-background cursor-pointer"
            title="Help"
          >
            <img
              alt="Help"
              height="28"
              width="28"
              (click)="Helpmodal($event)"
              [src]="ICON_PATHS.HELP_ICON"
            />
          </div>
          <button
            *ngIf="
              this.notificationCount === null || this.notificationCount === 0
            "
            mat-icon-button
            (click)="sidenavService.open(tempRef)"
            (click)="getNotification()"
          >
            <mat-icon class="icon-white">{{ ICONS.NOTIFICATIONS }}</mat-icon>
          </button>
          <button
            *ngIf="this.notificationCount !== null"
            mat-icon-button
            (click)="sidenavService.open(tempRef)"
            (click)="getNotification()"
          >
            <mat-icon
              class="icon-white"
              matBadge="{{ notificationCount }}"
              matBadgeColor="warn"
            >
              {{ ICONS.NOTIFICATIONS }}
            </mat-icon>
          </button>
          <button
            [disabled]="!userInfo?.is_multi_tenant"
            type="button"
            class="brand-logo-container cursor-pointer d-flex align-items-center justify-content-center"
            (click)="showTenantInfo()"
            [attr.aria-disabled]="!userInfo?.is_multi_tenant"
            aria-label="View tenant information"
          >
            <div
              *ngIf="!profilePicture"
              class="brand-logo-skeleton"
            ></div>
            <img
              *ngIf="profilePicture"
              [src]="profilePicture"
              alt="Brand Logo"
              class="himalaya-brand-logo-main"
              (error)="onProfilePicError($event)"
            />
          </button>
          <div class="tenant-name-container d-flex align-items-center">
            <h5 class="user-name mb-0">{{ this.userInfo.user_name }}</h5>
          </div>
          <button
            type="button"
            class="icon-background"
            (click)="Logout()"
            aria-label="Logout"
          >
            <mat-icon
              title="Logout"
              class="icon-white"
            >
              {{ ICONS.LOGOUT }}
            </mat-icon>
          </button>
        </ul>
      </div>
    </div>
  </nav>
  <div
    *ngIf="helpModal"
    (click)="$event.stopPropagation()"
  >
    <p class="helpText">
      <span class="help1">
        Help
        <br />
      </span>
      Please send us an email if you have any question, facing difficulties, or
      want to share your feedback with us. We are happy to support you!
      <br />
      <a
        href="mailto:deductionshelp@inmar.com"
        class="help2"
      >
        deductionshelp&#64;inmar.com
      </a>
    </p>
  </div>
  <div
    class="nav-container-1 mt-5 p-0 m-0 fixed-top nav-box-shadow"
    *ngIf="showManageMenu"
  >
    <div class="row p-0 m-0">
      <div
        class="col-xl-12 mx-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 tab-container"
      >
        <mat-tab-group
          (selectedTabChange)="selectMenu($event)"
          [(selectedIndex)]="SelectedTab"
        >
          <mat-tab
            [label]="tabs.tab"
            *ngFor="let tabs of listOfTabs; let index = index"
            [routerLink]="tabs.routePath"
          >
            <ng-template mat-tab-label>
              {{ tabs.tab }}
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>

  <div
    class="nav-container-1 mt-5 p-0 m-0 fixed-top nav-container-boxshadow"
    *ngIf="showReportMenu"
  >
    <div class="row p-0 m-0">
      <div
        class="col-xl-12 mx-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 tab-container"
      >
        <mat-tab-group
          (selectedTabChange)="selectReportMenu($event)"
          [(selectedIndex)]="SelectedReportTab"
          [@.disabled]="true"
        >
          <mat-tab
            [label]="tabs.tab"
            *ngFor="let tabs of reportMenu; let index = index"
            [routerLink]="tabs.routePath"
          >
            <ng-template mat-tab-label>
              {{ tabs.tab }}
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>

  <div
    class="nav-container-1 mt-5 p-0 m-0 fixed-top nav-container-boxshadow"
    *ngIf="showConnectorMenu"
  >
    <div class="row p-0 m-0">
      <div
        class="col-xl-12 mx-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 tab-container"
      >
        <mat-tab-group
          (selectedTabChange)="selectConnectorMenu($event)"
          [(selectedIndex)]="SelectedConnectorTab"
          [@.disabled]="true"
        >
          <mat-tab
            [label]="tabs.tab"
            *ngFor="let tabs of connectorMenu; let index = index"
            [routerLink]="tabs.routePath"
          >
            <ng-template mat-tab-label>
              {{ tabs.tab }}
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>

  <ng-template #tempRef>
    <div class="d-flex flex-column gap-2 notification-wrapper">
      <div
        class="flex-grow-1 d-flex flex-row justify-content-between align-items-center"
      >
        <div
          class="d-flex flex-row justify-content-start align-items-center gap-2"
        >
          <button
            type="button"
            class="notification-close-button"
            (click)="sidenavService.close()"
            aria-label="Close notifications"
          >
            <mat-icon>{{ ICONS.CLOSE }}</mat-icon>
          </button>
          <span class="header">Notifications</span>
        </div>
        <div>
          <button
            type="button"
            class="clrAll"
            *ngIf="this.keys.length !== 0"
            (click)="clearAllNotification(0, 'clearAll')"
            aria-label="Clear all notifications"
          >
            clear all
          </button>
        </div>
      </div>
      <div
        *ngIf="this.keys.length === 0"
        class="text-center mt-5"
      >
        No data found.
      </div>
      <div *ngFor="let item of keys">
        <div>
          <span
            *ngIf="this.keys.length !== 0"
            class="dateTimeSts"
          >
            {{ item | replaceunderscore }}
          </span>
        </div>
        <div *ngFor="let notify of notification[item]">
          <div class="pb-10">
            <div class="card">
              <div
                *ngIf="notify.details.level !== 'jobs'"
                class="d-flex justify-content-between align-items-center"
              >
                <div class="d-flex align-items-center gap-2">
                  <img
                    alt="Message"
                    [src]="ICON_PATHS.MESSAGE"
                  />
                  <span class="sender">
                    {{ this.getNameByID(notify.sender) }}
                  </span>
                </div>
                <small class="notifyTime">
                  {{ getEST(notify?.time) | transformDateTime: 'time' }}
                </small>
              </div>
              <div
                *ngIf="notify.details.level === 'jobs'"
                class="d-flex justify-content-between align-items-center"
              >
                <div class="d-flex align-items-center gap-2">
                  <mat-icon class="icon-outlined icon-success icon-md">
                    {{ ICONS.TICK_ROUND }}
                  </mat-icon>
                  <span class="sender">Processing Completed</span>
                </div>
                <small class="notifyTime">
                  {{ getEST(notify?.time) | transformDateTime: 'time' }}
                </small>
              </div>

              <div class="d-flex justify-content-between align-items-center">
                <span class="notifyMsg">
                  {{ shortMsg(notify.message) }}
                  {{ notify.message.length < 80 ? '' : '...' }}
                </span>
                <button
                  type="button"
                  class="clrAll"
                  *ngIf="this.keys.length !== 0"
                  (click)="
                    clearAllNotification(notify?.notification_id, 'clear')
                  "
                  aria-label="Clear this notification"
                >
                  clear
                </button>
              </div>
              <div *ngIf="notify.details.level === 'invoices'">
                <span class="invoiceNumber">
                  <a (click)="openActivitySideNavBar(notify)">
                    {{ notify.details.number }}
                  </a>
                </span>
              </div>
              <div *ngIf="notify.details.level === 'jobs'">
                <span class="invoiceNumber">
                  Go To
                  <a (click)="openActivitySideNavBar(notify)">My Downloads</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
